import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { forEach } from 'lodash-es';
import { SimplePopover } from '@dev/ee-components';

import { getCampaignsNamesStore } from '@/store/campaigns/actions';
import { useGetAutomatedInfo } from '@/components/CampaignCreator/SettingsAndTracking/hooks/useGetAutomatedInfo';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';

export const FromOption = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const campaignsNames = useSelector(getCampaignsNamesStore);
    const { triggerChannelName } = useGetAutomatedInfo();

    const [campaignNameTrigger, setCampaignTrigger] = useState(triggerChannelName);

    const clickOnItemHandler = (e, obj: { value: string; label: string }): void => {
        setCampaignTrigger(obj.value);
        const modifyMap = new Map<string, any>();
        modifyMap.set('TriggerOptions.TriggeredBy.ChannelName', obj.value);
        dispatch(ModifyCampaignMap(modifyMap));
    };

    const campaigns = [
        {
            label: t('anycampaign'),
            value: null,
        },
    ];

    forEach(campaignsNames, (value) => {
        campaigns.push({ label: value, value });
    });

    return (
        <SimplePopover
            id="autoresponder-from-dropdown"
            label={t('from')}
            options={campaigns}
            type="input"
            fullWidth
            maxHeight={320}
            defaultValue={null}
            value={campaignNameTrigger}
            onItemClick={clickOnItemHandler}
            placement="bottom-start"
        />
    );
};
